import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { CreateAccountFormComponent } from '../../../components/forms/dynamic-forms/create-account-form/create-account-form.component';
import { MapfreAlertComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { FindPolicyInfoModalComponent } from './find-policy-info-modal/find-policy-info-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';

import { CreateAccountService } from '../../../_services/forms/create-account/create-account-service.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, FindPolicyInfoModalComponent, MapfreAlertComponent, CreateAccountFormComponent, MapfreButtonComponent],
  selector: 'app-signup-process',
  templateUrl: './signup-process.component.html',
  providers: [CreateAccountService],
})
export class SignupProcessComponent implements OnInit {
  inputs: any[];
  isAcmic: boolean;

  constructor(
    service: CreateAccountService,
    private acmicService: AcmicService,
    private location: Location,
    private titleService: Title,
    private meta: Meta
  ) {
    this.inputs = service.getInputs();
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.titleService.setTitle('Create a Personal Insurance Customer Account | Mapfre Insurance');
    this.meta.updateTag({ name: 'description', content: 'Create a customer account and manage your Mapfre Insurance personal auto or home policy with ease.' });
  }
  goBack() {
    this.location.back();
  }
}
